import TableList from "@components/templates/tablelist";
import { HttpGetReciveList, HttpChangeStatus, HttpCopyReviceOne} from "@/service/tasks";
import { mapGetters } from "vuex";
import compDetail from '../receiveoffer/update';
import compAddTemp from '../receiveoffer/addtemp';
export default {
    mixins: [TableList],
    components:{
        compDetail,
        compAddTemp
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90
            },
            formData: {
                search: {
                    EQ_billingChannel:1,
                }
            },
            Plugins: { show: true }
        };
    },

    methods: {
        ajaxRequest: HttpGetReciveList,
        interceptRequest(params) {
            params.search.EQ_billingChannel = 1
            return params
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$Message.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "add":
                    this.operate = {
                        title: this.$t('global.common.add', { defaultValue: '添加' }),
                        show: true,
                        width: 500,
                        component: "compAddTemp",
                        activeid: params,
                        querytype:'query',
                        showFooter: false
                    }
                    break;
                case "edit":
                    var url1=this.$router.resolve({
                        name: "tasksPayableofferUpdate",
                        params: { type: "edit" },
                        query: { id: params},
                    });
                    window.open(url1.href, '_blank');
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1250,
                        component: "compDetail",
                        activeid: params,
                        querytype:'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "tasksPayableofferUpdate",
                        params: { type: "query" },
                        query: { id: params},
                    });
                    window.open(url.href, '_blank');
                    break;
                case "active":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params,status:1 },
                        title: this.$t('fbb.accountmanage.active', { defaultValue: '启用' }),
                        ajaxRequest: HttpChangeStatus
                    };
                    break;
                case "disable":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        params: { id: params,status:0 },
                        title: this.$t('fbb.accountmanage.disable', { defaultValue: '禁用' }),
                        ajaxRequest: HttpChangeStatus
                    };
                    break;
                case "copy":
                    this.operate = {
                        show: true,
                        alert: "info",
                        params: { id: params },
                        title: '复制模板',
                        ajaxRequest: HttpCopyReviceOne
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row;
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    params: id,
                    show: true,
                    operate: "query"
                },
                {
                    label: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                    params: id,
                    show: true,
                    operate: "edit"
                },
                {
                    label: this.$t('fbb.accountmanage.active', { defaultValue: '启用' }),
                    params: id,
                    show: status == 0,
                    operate: "active"
                },
                {
                    label: this.$t('fbb.accountmanage.disable', { defaultValue: '禁用' }),
                    params: id,
                    show: status == 1,
                    operate: "disable"
                },
                {
                    label: '复制模板',
                    params: id,
                    show: true,
                    operate: "copy"
                },
            ];
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getCusBillTypeList']),
        ToolsData() {
            return [
                {
                    name: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    operate: "add",
                    theme: "primary"
                },
            ];
        },
        SearchsData() {
            return [
                // {
                //     label: '费用类型',
                //     tag: 'div',
                //     show:true,
                //     children:(h)=>{
                //         return h("compMultipleSelect",{
                //             props: {
                //                 options:this.getCusBillTypeList,
                //                 modelValue:this.formData.search.IN_expenseCategoryType,
                //                 placeholder:'承运商',
                //                 // isShowCheckAll:false,//是否展示全选按钮
                //             },
                //             on:{
                //                 'update:modelValue':(val)=>{
                //                     this.formData.search.IN_expenseCategoryType = val
                //                 }
                //             }
                //         })
                //     }
                // },
                {
                    label: '费用类型',
                    tag: "Select",
                    key: "EQ_expenseCategoryType",
                    show: true,
                    // options: this.getCusBillTypeList
                    options: [
                        { value: 0, label: '作业费' },
                        { value: 1, label: '仓储费' },
                        { value: 3, label: '增值服务费' },
                    ],
                },
                {
                    label: '模板代码',
                    tag: "Input",
                    key: "EQ_code",
                    show: true,
                },
                {
                    label: '模板名称',
                    tag: "Input",
                    key: "CN_name",
                    show: true,
                },
                {
                    label: '计价方案代码',
                    tag: "Input",
                    key: "EQ_billingPlanCode",
                },
                {
                    label: this.$t('global.common.status', { defaultValue: '状态' }),
                    tag: "Select",
                    key: "EQ_status",
                    options: [
                        {value:0,label:'禁用'},
                        {value:1,label:'启用'},
                    ]
                }
            ];
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    maxWidth: 90,
                    render: this.getOperateNodes
                },
                {
                    title: '费用类型',
                    key: "code",
                    sortable: true,
                    render:(h,{row})=>{
                        return <div>{this.findRenderLabel(this.getCusBillTypeList, row.expenseCategoryType)}</div>
                    }
                },
                {
                    title: '模板代码',
                    key: "code",
                    width:120,
                    sortable: true,
                    render:(h,{row})=>{
                        return <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.code}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                    }
                },
                {
                    title: '模板名称',
                    key: "name",
                    render:(h,{row})=>{
                        return <div>{row.name || '--'}</div>
                    }
                },
                {
                    title: "计价方案",
                    key: "billingPlanCode",
                    render:(h,{row})=>{
                        return <div>{row.billingPlanCode || '--'}</div>
                    }
                },
                {
                    title: '备注',
                    key: "description",
                    render:(h,{row})=>{
                        return <div>{row.description || '--'}</div>
                    }
                },
                {
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: "status",
                    width:100,
                    render:(h,{row})=>{
                        return <div>
                            <Tag type="border" v-show={row.status === 1} color="success">启用</Tag>
                            <Tag type="border" v-show={row.status !== 1} color="default">禁用</Tag>
                        </div>
                    }
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    key: "updatedAt"
                }
            ];
        }
    }
};
